import { Component, inject } from '@angular/core';
import { LeafletService } from '../../services/leaflet';
import { LeafletDirective, LeafletModule } from '@bluehalo/ngx-leaflet';
import { AutoSyncService } from '../../services/auto-sync';

@Component({
  selector: 'app-map',
  imports: [LeafletDirective, LeafletModule],
  template: `
    <div leaflet
    style="min-height:280px"
      [leafletOptions]="leafletService.options()"
      [leafletLayers]="leafletService.layers()"
      [leafletFitBounds]="leafletService.fitBounds()"
      [leafletFitBoundsOptions]="leafletService.fitBoundsOptions()"
      (leafletMapReady)="leafletService.onMapReady($event)"
      (leafletClick)="leafletService.addSyncMarker($event.latlng)">
    </div>
  `,
  styleUrl: './map.scss',
})
export class Map {
  public readonly leafletService: LeafletService = inject(LeafletService);
  public readonly autoSyncService: AutoSyncService = inject(AutoSyncService);
}
